module.exports = __webpack_public_path__ + "static/media/ic_help_coming_up.4d3595c9.png";